import PropTypes from 'prop-types';

export const BusinessUnitPropTypes = PropTypes.shape({
  ancestorList: PropTypes.string,
  businessUnitDescription: PropTypes.string,
  businessCode: PropTypes.string,
  businessDescription: PropTypes.string,
  businessUnit: PropTypes.string.isRequired,
  enabledFlag: PropTypes.string.isRequired,
  marsParent: PropTypes.string,
  periodName: PropTypes.string.isRequired,
});

export const BusinessUnitsPropTypes = PropTypes.arrayOf(BusinessUnitPropTypes).isRequired;
